import api from './api';

const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

export const getExpenseReport = (slug, params) => api.get(`/v1/expense-reports/${slug}`, { params: clean(params) });
export const getExpenseReportFilters = (params) => api.get('/v1/expense-reports/filters', { params: clean(params) });
export const exportExpenseReport = (slug, params) =>
  api.get(`/v1/expense-reports/${slug}/export`, { params: clean(params), responseType: 'blob' });
